import React, { useEffect, useState } from "react";
import { useUser } from "../../../context/UserContext";
import "./SavedGlobalContacts.css";
import SavedContactTab from "./SavedContactTab";
import SavedContactContent from "./SavedContactContent";

const VerticalTabsSkeleton = () => {
  return (
    <div className="sgc-tabs-skeleton">
      {[...Array(15)].map((_, i) => (
        <div key={i} className="sgc-tab-skel-line" />
      ))}
    </div>
  );
};

const SavedContactContentSkeleton = () => {
  return (
    <div className="sgc-content-skeleton">
      <div className="sgc-skel-header"></div>

      <div className="sgc-skel-table">
        {[...Array(15)].map((_, rowIndex) => (
          <div key={rowIndex} className="sgc-skel-row">
            {[...Array(4)].map((__, colIndex) => (
              <div key={colIndex} className="sgc-skel-cell"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

function SavedGlobalContacts({ tabs, loading, handleDeleteList }) {
  const tabsWithDEf = [
    {
      defaultList: true,
      id: Date.now().toString() + "all_contacts",
      name: "All Contacts",
      contacts: [],
    },
    ...tabs,
  ];
  const { user } = useUser();
  const [activeIndex, setActiveIndex] = useState(0);

  // ---- Fetch Saved Contacts ----

  // ---- UI States ----
  if (loading) {
    return (
      <div className="sgc-wrapper">
        <div className="sgc-tabs-list">
          <VerticalTabsSkeleton />
        </div>
        <div className="sgc-content-area">
          <SavedContactContentSkeleton />
        </div>
      </div>
    );
  }

  if (!tabsWithDEf.length)
    return <div className="sgc-no-data">No saved contacts found.</div>;

  const activeTabData = tabsWithDEf[activeIndex];

  return (
    <div className="sgc-wrapper">
      {/* ---------- LEFT: TAB LIST ---------- */}
      <div className="sgc-tabs-list">
        {tabsWithDEf?.map((item, index) => (
          <div
            key={item?._id ?? index}
            className={`sgc-tab ${index === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
          >
            <SavedContactTab
              content={item}
              onDelete={handleDeleteList}
              defaultList={item?.defaultList === true}
            />
          </div>
        ))}
      </div>

      {/* ---------- RIGHT: TAB CONTENT ---------- */}
      <div className="sgc-content-area">
        <SavedContactContent content={activeTabData} />
      </div>
    </div>
  );
}

export default SavedGlobalContacts;
